export default __webpack_public_path__ + "static/media/water-pic-2.9d31d5e4.svg";